import { Link } from "react-router-dom";
import { Home, Building2, ArrowRight, CalendarCheck, Wallet, ListChecks } from "lucide-react";
import { PlannerShell } from "@/components/planner/PlannerShell";
import { CallbackCard } from "@/components/planner/CallbackCard";
import { planHome } from "@/lib/plannerApi";

const CARDS = [
    { type: "HOME", icon: Home, title: "My Home Essentials Planner",
      body: "Monthly groceries, cleaning, toiletries, puja and everything your family regularly needs.",
      tone: "from-emerald-600 to-emerald-700" },
    { type: "BUSINESS", icon: Building2, title: "My Business Essentials Planner",
      body: "Hotels, restaurants, cafés, schools, hostels, offices and guest houses — organised by department.",
      tone: "from-slate-800 to-slate-900" },
];

export default function PlannerEntry() {
    return (
        <PlannerShell>
            <div data-testid="planner-entry">
                <h1 className="text-4xl sm:text-5xl font-black text-slate-900 leading-tight" style={{ fontFamily: "'Chivo',sans-serif" }}>
                    Plan Your Essentials
                </h1>
                <p className="text-slate-600 mt-3 max-w-2xl">
                    Build your list once, reuse it every month. No payment needed to start — we send you a quotation when you're ready.
                </p>
                <div className="grid md:grid-cols-2 gap-4 mt-8">
                    {CARDS.map(({ type, icon: Icon, title, body, tone }) => (
                        <Link key={type} to={planHome(type)} data-testid={`planner-card-${type.toLowerCase()}`}
                              className={`group rounded-3xl bg-gradient-to-br ${tone} text-white p-7 md:p-9 shadow-lg hover:shadow-2xl hover:-translate-y-0.5 transition-[transform,box-shadow] duration-200`}>
                            <div className="w-12 h-12 rounded-2xl bg-white/15 grid place-items-center"><Icon size={24}/></div>
                            <div className="text-2xl font-black mt-5" style={{ fontFamily: "'Chivo',sans-serif" }}>{title}</div>
                            <p className="text-white/80 text-sm mt-2 leading-relaxed">{body}</p>
                            <div className="mt-6 inline-flex items-center gap-2 font-bold text-sm">
                                Start planning <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform"/>
                            </div>
                        </Link>
                    ))}
                </div>
                <div className="grid sm:grid-cols-3 gap-3 mt-8 text-sm">
                    <Fact icon={ListChecks} title="Save without ordering" body="Lists of any size are saved automatically."/>
                    <Fact icon={CalendarCheck} title="Planned delivery" body="We deliver on a schedule that suits you."/>
                    <Fact icon={Wallet} title="UPI or cash on delivery" body="Minimum confirmed order ₹4,000."/>
                </div>
                <div className="mt-8"><CallbackCard/></div>
            </div>
        </PlannerShell>
    );
}

const Fact = ({ icon: Icon, title, body }) => (
    <div className="rounded-2xl bg-white border border-slate-200 p-4">
        <Icon size={18} className="text-emerald-700"/>
        <div className="font-bold text-slate-900 mt-2">{title}</div>
        <div className="text-slate-500 text-xs mt-1">{body}</div>
    </div>
);
